/**
 * @generated SignedSource<<4c4f8339994763337f60d456c9df1b32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type StudentSingleSkillTargetGroupQuery$variables = {
  skip: boolean;
  studentId: string;
};
export type StudentSingleSkillTargetGroupQuery$data = {
  readonly currentTargetGroupByStudentId?: {
    readonly id: string;
    readonly isActive: boolean;
    readonly isCurrent: boolean;
    readonly targetGroup: {
      readonly id: string;
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly user: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type StudentSingleSkillTargetGroupQuery = {
  response: StudentSingleSkillTargetGroupQuery$data;
  variables: StudentSingleSkillTargetGroupQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "studentId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "studentId",
            "variableName": "studentId"
          }
        ],
        "concreteType": "StudentTargetGroupNode",
        "kind": "LinkedField",
        "name": "currentTargetGroupByStudentId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isCurrent",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TargetGroupNode",
            "kind": "LinkedField",
            "name": "targetGroup",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StudentSingleSkillTargetGroupQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StudentSingleSkillTargetGroupQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "b950ec2fce8aa867e2a8486cf2ab7aa5",
    "id": null,
    "metadata": {},
    "name": "StudentSingleSkillTargetGroupQuery",
    "operationKind": "query",
    "text": "query StudentSingleSkillTargetGroupQuery(\n  $studentId: ID!\n  $skip: Boolean!\n) {\n  currentTargetGroupByStudentId(studentId: $studentId) @skip(if: $skip) {\n    id\n    isCurrent\n    isActive\n    targetGroup {\n      id\n      name\n    }\n    user {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "210e0c579c6930d30dfc094ef596c142";

export default node;
